import React from 'react';
import { cn } from '../../utils/cn';

const variants = {
    primary: 'bg-primary-100 text-primary-800',
    secondary: 'bg-slate-100 text-slate-700',
    success: 'bg-success-100 text-success-800',
    warning: 'bg-warning-100 text-warning-800',
    danger: 'bg-danger-100 text-danger-800',
    slate: 'bg-slate-100 text-slate-800',
};

export const Badge = ({ className, variant = 'slate', children, ...props }) => {
    return (
        <span
            className={cn(
                'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
                variants[variant],
                className
            )}
            {...props}
        >
            {children}
        </span>
    );
};
